import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';

type Props = {
  value: string;
  onChange: (value: string) => void;
  countries: string[];
};

export const CountryFilter = ({ value, onChange, countries }: Props) => {
  const { translations } = useLanguage();

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500"
    >
      <option value="">
        {translations?.filters?.allCountries || 'All Countries'}
      </option>
      {countries.map((country) => (
        <option key={country} value={country}>
          {country}
        </option>
      ))}
    </select>
  );
};
